import { render, staticRenderFns } from "./company-body-operate.vue?vue&type=template&id=54de6458&scoped=true"
import script from "./company-body-operate.vue?vue&type=script&setup=true&lang=js"
export * from "./company-body-operate.vue?vue&type=script&setup=true&lang=js"
import style0 from "./company-body-operate.vue?vue&type=style&index=0&id=54de6458&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54de6458",
  null
  
)

export default component.exports